module.exports = __webpack_public_path__ + "static/media/dialog-bg.5909dead.svg";